module.exports = __webpack_public_path__ + "img/master_share.8ce4c2f9.svg";